// US Map State Color Manager
document.addEventListener('DOMContentLoaded', function() {
  initializeMapColoring();
  
  // Re-initialize on Shopify section events
  document.addEventListener('shopify:section:load', function(event) {
    setTimeout(initializeMapColoring, 100);
  });
  
  document.addEventListener('shopify:section:unload', function(event) {
    // Clean up observers if necessary
    if (window.stateColorObservers) {
      window.stateColorObservers.forEach(observer => observer.disconnect());
    }
  });
  
  document.addEventListener('shopify:section:select', function(event) {
    setTimeout(initializeMapColoring, 100);
  });
  
  document.addEventListener('shopify:block:select', function(event) {
    setTimeout(initializeMapColoring, 100);
  });
});

function hideLoadingOverlay(mapContainer) {
  const loadingOverlay = mapContainer.querySelector('.rental-locations__loading-overlay');
  if (loadingOverlay) {
    loadingOverlay.classList.add('hidden');
    setTimeout(() => {
      loadingOverlay.style.display = 'none';
    }, 300); // Match the CSS transition duration
  }
  
  // Remove loading class from container
  mapContainer.classList.remove('loading');
  
  // Clear any fallback timeouts
  if (mapContainer.fallbackTimeout) {
    clearTimeout(mapContainer.fallbackTimeout);
    delete mapContainer.fallbackTimeout;
  }
}

function initializeMapColoring() {
  // Store observers for cleanup
  if (!window.stateColorObservers) {
    window.stateColorObservers = [];
  }
  
  // Find all map containers (works with both team-map and rental-locations__map-container)
  const mapContainers = document.querySelectorAll('.team-map, .rental-locations__map-container');
  if (!mapContainers.length) return;

  // Process each map container
  mapContainers.forEach(mapContainer => {
    // Add loading class initially
    mapContainer.classList.add('loading');
    
    // Fallback timeout to hide loading overlay if something goes wrong
    mapContainer.fallbackTimeout = setTimeout(() => {
      if (mapContainer.classList.contains('loading')) {
        console.warn('Map loading timeout reached, hiding overlay');
        hideLoadingOverlay(mapContainer);
      }
    }, 5000); // 5 second timeout
    // Function to update the SVG with state colors
    const updateMapColors = (svg) => {
      if (!svg) return;
      
      // Get all state color data attributes from the container
      const dataAttributes = mapContainer.attributes;
      const stateColors = {};
      
      // Extract state colors from data attributes (format: data-state-XX where XX is the state code)
      for (let i = 0; i < dataAttributes.length; i++) {
        const attr = dataAttributes[i];
        if (attr.name.startsWith('data-state-')) {
          const stateCode = attr.name.substring(11).toUpperCase(); // Extract state code (e.g., AL, CA)
          stateColors[stateCode] = attr.value;
        }
      }
      
      // If we have fallback region colors, store them too
      const regionColors = {
        west: mapContainer.getAttribute('data-west-color'),
        midwest: mapContainer.getAttribute('data-midwest-color'),
        south: mapContainer.getAttribute('data-south-color'),
        northeast: mapContainer.getAttribute('data-northeast-color'),
        special: mapContainer.getAttribute('data-special-color')
      };
      
      // Map of states to regions (for fallback)
      const stateToRegion = {
        // West states
        WA: 'west', OR: 'west', CA: 'west', NV: 'west', ID: 'west', 
        MT: 'west', WY: 'west', UT: 'west', CO: 'west', AZ: 'west', NM: 'west',
        // Midwest states
        ND: 'midwest', SD: 'midwest', NE: 'midwest', KS: 'midwest', MN: 'midwest',
        IA: 'midwest', MO: 'midwest', WI: 'midwest', IL: 'midwest', IN: 'midwest',
        MI: 'midwest', OH: 'midwest',
        // South states
        TX: 'south', OK: 'south', AR: 'south', LA: 'south', MS: 'south',
        AL: 'south', TN: 'south', KY: 'south', WV: 'south', VA: 'south',
        NC: 'south', SC: 'south', GA: 'south', FL: 'south',
        // Northeast states
        ME: 'northeast', NH: 'northeast', VT: 'northeast', MA: 'northeast',
        RI: 'northeast', CT: 'northeast', NY: 'northeast', PA: 'northeast',
        NJ: 'northeast', DE: 'northeast', MD: 'northeast', DC: 'northeast',
        // Special states
        AK: 'special', HI: 'special'
      };
      
      // Find all state paths in the SVG and color them
      const paths = svg.querySelectorAll('path');
      paths.forEach(path => {
        const id = path.getAttribute('id');
        
        // Check if this is a state path (format: XX_path_n)
        if (id && id.match(/^[A-Z]{2}_path_\d+$/)) {
          const stateCode = id.substring(0, 2).toUpperCase();
          
          // Apply color in order of priority:
          // 1. Direct state color from data attribute
          // 2. Region color if state has a region
          // 3. Keep original color
          if (stateColors[stateCode]) {
            path.setAttribute('fill', stateColors[stateCode]);
          } else if (stateToRegion[stateCode] && regionColors[stateToRegion[stateCode]]) {
            path.setAttribute('fill', regionColors[stateToRegion[stateCode]]);
          }
        }
      });
    };
    
    // Process inlined SVG 
    const processInlineSVG = () => {
      const svgElement = mapContainer.querySelector('svg');
      if (svgElement) {
        updateMapColors(svgElement);
        // Hide loading overlay after styling is complete
        setTimeout(() => {
          hideLoadingOverlay(mapContainer);
        }, 100);
        return true;
      }
      return false;
    };
    
    // Process SVG image (convert to inline)
    const processSVGImage = () => {
      const svgImage = mapContainer.querySelector('img.map-image');
      if (!svgImage || !svgImage.src.includes('us-map.svg')) return false;
      
      // Add load event listener to handle when image loads before JS processes it
      svgImage.addEventListener('load', () => {
        // Add small delay to ensure image is rendered
        setTimeout(() => {
          if (mapContainer.classList.contains('loading')) {
            // If still loading, proceed with conversion
            convertImageToSVG();
          }
        }, 50);
      });
      
      const convertImageToSVG = () => {
        fetch(svgImage.src)
          .then(response => response.text())
          .then(svgText => {
            // Replace the img with the inline SVG
            const parser = new DOMParser();
            const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
            const svgElement = svgDoc.documentElement;
            
            // Apply settings for sharp display
            svgElement.setAttribute('class', svgImage.className);
            svgElement.setAttribute('width', svgImage.width || '1224');
            svgElement.setAttribute('height', svgImage.height || '711');
            svgElement.setAttribute('preserveAspectRatio', 'xMidYMid meet');
            svgElement.setAttribute('shape-rendering', 'geometricPrecision');
            
            // Replace img with SVG element
            svgImage.parentNode.replaceChild(svgElement, svgImage);
            
            // Update colors on the new SVG
            updateMapColors(svgElement);
            
            // Hide loading overlay after styling is complete
            setTimeout(() => {
              hideLoadingOverlay(mapContainer);
            }, 100);
          })
          .catch(error => {
            console.error('Error loading SVG:', error);
            // Hide loading overlay even on error
            hideLoadingOverlay(mapContainer);
          });
      };
      
      // If image is already loaded, process immediately
      if (svgImage.complete) {
        setTimeout(convertImageToSVG, 50);
      } else {
        // Otherwise, it will be handled by the load event listener
      }
      
      return true;
    };
    
    // Try to process inline SVG first, then fallback to image tag
    if (!processInlineSVG()) {
      processSVGImage();
    }
    
    // Set up MutationObserver to detect attribute changes
    const observer = new MutationObserver(mutations => {
      let shouldUpdate = false;
      
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && 
           (mutation.attributeName.startsWith('data-state-') || 
            mutation.attributeName.startsWith('data-') && 
            mutation.attributeName.endsWith('-color'))) {
          shouldUpdate = true;
        }
      });
      
      if (shouldUpdate) {
        const svgElement = mapContainer.querySelector('svg');
        if (svgElement) {
          updateMapColors(svgElement);
        }
      }
    });
    
    // Start observing for data attribute changes
    observer.observe(mapContainer, { 
      attributes: true, 
      attributeFilter: Array.from(mapContainer.attributes)
        .map(attr => attr.name)
        .filter(name => name.startsWith('data-'))
    });
    
    // Store observer for later cleanup
    window.stateColorObservers.push(observer);
  });
} 